import { mapState, mapGetters, mapMutations } from "vuex";
import { Message } from "./message";
import { Logger } from "common/api.service";
import jwtService from "./jwt.service";
import Vue from "vue"
import { focusNext } from "./input-helper";
import { EditItem } from "components/edit-item";
import Axios from "axios";

type AxiosErrorData = {
    message?: string
    errors?: Record<string, string | string[]>
}

export default Vue.extend({
    methods: {

        ...mapMutations(['setLoading', 'resetLoading']),

        /**
         * 通常の通知メッセージ（右上に表示）
         * @param message 
         */
        notify(message) {
            this.$notify({
                'group': 'general',
                'type': 'primary',
                'text': message
            });
        },

        /**
         * 何かが成功したり完了したときの通知メッセージ（右上に表示）
         * @param message 
         */
        notifySuccess(message) {
            this.$notify({
                'group': 'general',
                'type': 'success',
                'text': message
            });
        },

        /**
         * エラーの通知メッセージ（中央上に表示）
         * @param message 
         */
        notifyError(message) {
            this.$notify({
                'group': 'error',
                'type': 'danger',
                'text': message
            });
        },

        /**
         * 通知のクリア
         */
        clearNotify() {
            this.$notify({
                group: 'general',
                clean: true
            })
        },

        /**
         * 通知のクリア
         */
        clearNotifyError() {
            this.$notify({
                group: 'error',
                clean: true
            })
        },

        focusNext(e: any) {
            focusNext(e)
        },

        /**
         * 求人番号を0埋めなしの求人番号にする
         */
        formatKyujinNoDisplay(kyujinNo: string): string {
            const iKyujinNo = parseInt(kyujinNo);
            return Number.isNaN(iKyujinNo) ? "" : iKyujinNo.toString()
        },

        exceptionHandle(e: any, message: string, editItems?: EditItem[]) {

            // 管理画面の編集画面の場合
            // let _editItems: EditItem[] | null = null;
            // if (typeof this.getAllEditItems !== 'undefined') {
            //     _editItems = this.getAllEditItems();
            // } else if (typeof this.editItems !== 'undefined') {
            //     _editItems = this.editItems;
            // }

            const hasEditItem = editItems != null

            //通信時エラーの場合
            if (Axios.isAxiosError(e)) {

                const data = e.response.data as AxiosErrorData
                const isValidationError = data.errors != null

                if (hasEditItem && isValidationError) {
                    const errors = data.errors

                    //もしerrosが存在する=ValidationErrorであり、editItemsも存在するならば、バリデーションエラーの表示を行う。
                    for (let [key, error] of Object.entries(errors)) {

                        let searchkey = key.split(".").at(-1)
                        // if (searchkey === 'passwordValidate') {
                        //     searchkey = 'RawPassword'
                        // }
                        if (searchkey === 'RawPassword') {
                            searchkey = 'パスワード'
                        }

                        let editItem = editItems.find(x => x.id.toLowerCase() == searchkey.toLowerCase())

                        if (editItem) {
                            editItem.setError(error);
                        } else {
                            this.errorMessageSummary.push(`${error}`);
                        }
                    }
                    //エラー内容をまとめて通知
                    //登録ボタンに表示のほうがいいかもしれない？
                    this.notifyError(Object.values(errors).join("\r\n").trim())

                    //上までスクロール
                    window.scroll({ top: 0, behavior: 'smooth' });

                    Logger.logDebug(errors)

                } else if (isValidationError) {
                    //edititemはないけどValidationErrorと思われる場合、エラーの内容を表示する
                    const errors = data.errors as object;
                    let messages = Object.entries(errors).map((key, value) => `${key}: ${value}`)
                    if (messages.length != 0) {
                        this.notifyError(messages.join("\r\n"));
                        Logger.logDebug(e.response)
                    } else {
                        this.notifyError(e.message);
                        Logger.logDebug(e.response)
                    }

                } else {
                    //そうでないならば、サーバー側でのなんらかのエラー
                    this.notifyError(message + (data.message ?? ""));
                    Logger.logDebug(e)
                }
            } else {
                //通信時エラーでないならば、フロント側の処理エラー
                this.notifyError(message);
                Logger.logDebug(e)
            }

        },

        async setValueToEditItem(editItems: EditItem[], value: object) {


            for (const _id of Object.keys(value)) {
                const editItem = editItems.find(x => x.id == _id);
                if (editItem == null) {
                    continue;
                }

                editItem.setValue(value[_id]);
            }
            await this.$nextTick()

            return
        }

    },

    computed: {
        level(): number {
            return +jwtService.getLevel();
        },
        isReadOnlyUser(): boolean {
            // 1: Admin, 2: Normal, 3: ReadOnly
            return this.level == 3;
        }
    }
})